var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "08-clients",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "none",
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,61l-5.7-5.7c0.4-0.4,0.9-0.7,1.5-1c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.6,1.5,1l2.5,2.5 l8.1-8.1c0.4-0.4,0.9-0.7,1.5-1c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.6,1.5,1L32.4,61 c-0.8,0.8-2,1.3-3.2,1.3C28,62.3,26.9,61.8,26,61L26,61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.8,40.3L57.8,40.3c0-1.2-0.5-2.3-1.3-3.2c-0.8-0.8-2-1.3-3.2-1.3l-13.7,0c0,0,0,0,0,0l-7.6,0l-7.6,0c0,0,0,0,0,0 l-13.7,0c-1.2,0-2.3,0.5-3.2,1.3c-0.8,0.8-1.3,2-1.3,3.2l0,0l0,15.1c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.6,1.5-1 c0.4-0.4,0.8-0.9,1-1.5c0.2-0.5,0.3-1.1,0.3-1.7l0-10.5l21.3,0l21.3,0l0,10.5c0,0.6,0.1,1.2,0.3,1.7s0.6,1,1,1.5 c0.4,0.4,0.9,0.8,1.5,1c0.5,0.2,1.1,0.3,1.7,0.3L57.8,40.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,31.2c-8.1,0-14.7-6.6-14.7-14.7c0-8.1,6.6-14.7,14.7-14.7s14.7,6.6,14.7,14.7C46.7,24.6,40.1,31.2,32,31.2z M32,6.3 c-5.6,0-10.2,4.6-10.2,10.2c0,5.6,4.6,10.2,10.2,10.2s10.2-4.6,10.2-10.2C42.2,10.8,37.6,6.3,32,6.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.e5b03421c7b23afb443a1ce0f00774ca.svg";
export { ForwardRef as ReactComponent };